import React from 'react';

function Nicaragua(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124037)">
        <mask
          id="mask0_800_124037"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124037)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124037"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124037)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#0080EC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#0080EC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 8C18.212 8 18.4206 8.01303 18.6248 8.03824L18.4019 9.31428C18.2704 9.29887 18.1362 9.29092 18 9.29092C17.8018 9.29092 17.6081 9.30773 17.4205 9.33984L17.3163 8.04587C17.5393 8.01566 17.7676 8 18 8ZM19.2961 8.16841L18.9051 9.41239C20.1463 9.75506 21.0477 10.784 21.0477 12C21.0477 12.0299 21.0472 12.0597 21.0461 12.0893L22.4946 12.1985C22.4982 12.1327 22.5 12.0666 22.5 12C22.5 10.1914 21.1496 8.6631 19.2961 8.16841ZM21.9526 13.9136C21.2395 15.075 19.8974 15.8874 18.3333 15.9892V14.6931C19.1666 14.6125 19.899 14.2334 20.3924 13.6786L21.9526 13.9136ZM14.1489 14.0704C14.8959 15.1658 16.2177 15.9171 17.7425 15.9936V14.6996C16.8538 14.6335 16.0736 14.2285 15.5658 13.6304L14.1489 14.0704ZM13.5041 12.1715C13.5014 12.1146 13.5 12.0575 13.5 12C13.5 10.3016 14.6909 8.85038 16.3709 8.27018L16.7465 9.52993C15.6947 9.95232 14.9609 10.8899 14.9523 11.9807L13.5041 12.1715Z"
              fill="#D0AB00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.9716 8.94974L14.8926 13.6805H21.0989L17.9716 8.94974Z"
              fill="#7CDFFF"
            />
            <mask
              id="mask2_800_124037"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="14"
              y="8"
              width="8"
              height="6"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.9716 8.94974L14.8926 13.6805H21.0989L17.9716 8.94974Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124037)">
              <path
                d="M17.9998 15.1182C19.3938 15.1182 20.6271 14.1015 20.6271 12.7273C20.6271 11.3531 19.3938 10.3364 17.9998 10.3364C16.6058 10.3364 15.3726 11.3531 15.3726 12.7273C15.3726 14.1015 16.6058 15.1182 17.9998 15.1182Z"
                stroke="#E31D1C"
              />
              <path
                d="M17.9998 15.1182C19.3938 15.1182 20.6271 14.1015 20.6271 12.7273C20.6271 11.3531 19.3938 10.3364 17.9998 10.3364C16.6058 10.3364 15.3726 11.3531 15.3726 12.7273C15.3726 14.1015 16.6058 15.1182 17.9998 15.1182Z"
                stroke="#FFD018"
              />
              <path
                d="M17.9998 15.1182C19.3938 15.1182 20.6271 14.1015 20.6271 12.7273C20.6271 11.3531 19.3938 10.3364 17.9998 10.3364C16.6058 10.3364 15.3726 11.3531 15.3726 12.7273C15.3726 14.1015 16.6058 15.1182 17.9998 15.1182Z"
                stroke="#4EDD00"
              />
              <path
                d="M17.9998 15.1182C19.3938 15.1182 20.6271 14.1015 20.6271 12.7273C20.6271 11.3531 19.3938 10.3364 17.9998 10.3364C16.6058 10.3364 15.3726 11.3531 15.3726 12.7273C15.3726 14.1015 16.6058 15.1182 17.9998 15.1182Z"
                stroke="#3D58DB"
              />
              <rect
                x="14.6453"
                y="12.2182"
                width="7.03636"
                height="1.81818"
                fill="#3D58DB"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1165 12.9909L16.5189 11.7513L16.9493 12.3711L17.2499 11.6152L17.5839 12.1818L17.9346 11.7513L18.3884 12.1818L18.8045 11.6152L19.1601 12.1818L19.5682 11.7513L20.5217 12.652L20.6933 12.9909L15.1165 13.2424V12.9909Z"
                fill="#97C923"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124037">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Nicaragua;
